/**
 * @generated SignedSource<<11e7994f04831d9cdcf13ba90af324ef>>
 * @relayHash 4a5bc80de6cd84de8b2e86b0b606bb43
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a56055670be90edd8f70e095fc5815f6e9c8578279417f3f829ddea36a65dfcf

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardQuery } from './src_jiraBusinessBoardQuery.graphql';

import isSavedViewsBoardColumnSettingsEnabled_provider from '@atlassian/jira-relay-provider/src/saved-views-board-column-settings.relayprovider';
import withFiltersAndColumnSettings_provider from '@atlassian/jira-relay-provider/src/saved-views-board-filter-and-column-settings.relayprovider';
import withFilters_provider from '@atlassian/jira-relay-provider/src/saved-views-board-filter-setting.relayprovider';
import withSelectedWorkflow_provider from '@atlassian/jira-relay-provider/src/saved-views-board-selected-workflow-setting.relayprovider';
import isSaveResetViewEnabled_provider from '@atlassian/jira-relay-provider/src/sv-230-save-revert-board-view-settings.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a56055670be90edd8f70e095fc5815f6e9c8578279417f3f829ddea36a65dfcf",
    "metadata": {},
    "name": "src_jiraBusinessBoardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardcolumnsettingsrelayprovider": isSavedViewsBoardColumnSettingsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardfiltersettingrelayprovider": withFilters_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardselectedworkflowsettingrelayprovider": withSelectedWorkflow_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardfilterandcolumnsettingsrelayprovider": withFiltersAndColumnSettings_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsv230saverevertboardviewsettingsrelayprovider": isSaveResetViewEnabled_provider
    }
  }
};

export default node;
